module.exports = __webpack_public_path__ + "images/expand0e2c5a68495cef750b790813c7106a7c.svg";